export default {
    lable: 'See how you can strengthen your resume in three simple steps!',
    step1: 'Upload Resume',
    step2: 'Paste or Select Job Description',
    step3: 'Choose Template',
    step3: 'Get Score',
}